import * as Sentry from '@sentry/react';

const reported = new Set<string>();

/**
 * The backend can add an audited field or enum constant before the translation exists; the history then shows the raw key.
 * Reports the key once per page load, grouped by key, so the missing translation shows up as one Sentry issue naming it.
 */
export const reportMissingChangeTranslation = (key: string) => {
  if (reported.has(key)) return;
  reported.add(key);
  Sentry.captureMessage(`Missing change history translation: ${key}`, { level: 'warning', fingerprint: ['change-history-translation', key] });
};
